// prettier-ignore
export default "2025.0714.0815"